import React, { useContext } from "react";

//Material UI stuff
import TableCell from "@material-ui/core/TableCell";
import { CustomCircularLoader } from "../../materialUiComponents";

//global state
import { StateContext } from "../../AppStateContext";

//styling
import "./clusterRow.css";

//material ui
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

const ClusterRowInfoState = ({ clusterInfo }) => {
  const percentage = clusterInfo.data.status.state.percentage;

  //consume global state
  const state = useContext(StateContext);
  //this will return either a spinning circle with the current provisioning
  //percentage or the green check mark if it's ready. updates every 12 seconds

  return (
    <TableCell
      align="left"
      style={{
        borderBottom:
          state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      <span
        style={{ marginTop: "0", width: "30px", transform: "translateY(15px)" }}
      >
        {percentage === 100 ? (
          <CheckCircleOutlineIcon
            style={{ color: "#38d611", fontSize: "35px" }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              transform: "translateY(-5px)",
            }}
          >
            <CustomCircularLoader value={percentage} state={state} />
          </div>
        )}
      </span>
    </TableCell>
  );
};

export default ClusterRowInfoState;
